import { cn } from "@/lib/cn";
import { getAvatarUrl } from "@/lib/avatar";

interface UserAvatarProps {
  avatarUrl: string | null | undefined;
  userId: string;
  displayName: string;
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
}

const SIZE_CLASSES = {
  xs: "h-6 w-6",
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-16 w-16",
} as const;

export function UserAvatar({
  avatarUrl,
  userId,
  displayName,
  size = "sm",
  className,
}: UserAvatarProps) {
  const src = getAvatarUrl(avatarUrl, userId);

  return (
    <img
      src={src}
      alt={displayName}
      className={cn("rounded-full object-cover", SIZE_CLASSES[size], className)}
      loading="lazy"
    />
  );
}
